import { render, staticRenderFns } from "./section10.vue?vue&type=template&id=ad08423c"
import script from "./section10.vue?vue&type=script&lang=js"
export * from "./section10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports